import axios from '@/api';

/**
 * Feature flags — set to false to hide UI until backend is ready.
 * share: PATCH /rebates/bulk-status marks selected codes as shared (status 2).
 *        The endpoint does not revert shared → available.
 */
export const REBATE_FEATURES = {
    share: true,
    delete: true,
    combine: true,
};

export function listRebates(competitionId) {
    return axios.get(`panel/competitions/${competitionId}/rebates`);
}

export function generateRebates(competitionId, payload) {
    return axios.post(`panel/competitions/${competitionId}/rebates`, payload);
}

/** Bulk delete — only status 1 (available) can be deleted */
export function deleteRebates(competitionId, ids) {
    return axios.delete(`panel/competitions/${competitionId}/rebates`, {
        data: { ids },
    });
}

/** Bulk mark rebates as shared (status = 2). */
export function bulkUpdateRebatesStatus(competitionId, ids) {
    return axios.patch(`panel/competitions/${competitionId}/rebates/bulk-status`, { ids });
}

/** Settings field rebatesCombine: boolean */
export function updateRebatesCombine(competitionId, rebatesCombine) {
    return axios.put(`panel/competitions/${competitionId}/settings`, {
        rebatesCombine: Boolean(rebatesCombine),
    });
}
